export const SET_AGREEMENT_ID = 'SET_AGREEMENT_ID';
export const SET_AGREEMENT_INFO_BY_ID = 'SET_AGREEMENT_INFO_BY_ID';
export const RESET_EDIT_AGREEMENT = 'RESET_EDIT_AGREEMENT';
